import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, FormGroup, Input } from 'reactstrap'
import Recaptcha from 'react-recaptcha'

import ResponseAlert from '../../../partials/ResponseAlert'

import config from '../../../../config'
import style from '../../style'

const SignupForm = props => {
  return (
    <Col
      tag='form'
      xs='12'
      sm='6'
      className={css(style.box.wrapper)}
      onSubmit={props.onFormSubmit}
    >
      <Row tag='header'>
        <Col className={css(style.box.header)}>I'm a new customer</Col>
      </Row>
      <Row className={css(style.form.wrapper)}>
        <Col>
          {!props.response ? null : (
            <ResponseAlert
              statusCode={props.response.statusCode}
              alert={+props.response.statusCode >= 400 ? 'danger' : 'success'}
              content={props.response.data.message}
              altContent={
                +props.response.statusCode < 300
                  ? 'Success! Please, check your inbox now.'
                  : null
              }
            />
          )}
        </Col>
        <RenderInput
          name={`firstName`}
          value={props.editor.firstName}
          onChange={props.onInputChange}
          placeholder={`First Name`}
        />
        <RenderInput
          name={`lastName`}
          value={props.editor.lastName}
          onChange={props.onInputChange}
          placeholder={`Last Name`}
        />
        <RenderInput
          name={`email`}
          value={props.editor.email}
          onChange={props.onInputChange}
          placeholder={`Email`}
        />
        <RenderInput
          name={`phone`}
          value={props.editor.phone}
          onChange={props.onInputChange}
          placeholder={`Phone Number`}
        />
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Recaptcha
              sitekey={config.recaptcha_sitekey}
              verifyCallback={props.onCaptchaVerify}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row tag='footer'>
        <Col className={`d-flex justify-content-end ${css(style.box.footer)}`}>
          <input
            type='submit'
            value='Register'
            className={css(style.form.submit)}
          />
        </Col>
      </Row>
    </Col>
  )
}

const RenderInput = props => {
  return (
    <Col xs='12'>
      <FormGroup className={css(style.form.formGroup)}>
        <Input
          type={props.type || `text`}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
          className={css(style.form.input, style.form.singleRowInput)}
        />
      </FormGroup>
    </Col>
  )
}

export default SignupForm



// WEBPACK FOOTER //
// ./src/components/Register/partials/SignupForm/index.js